export default "__VITE_ASSET__B4HvgI1c__"